import { useNavigate } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { usePackages } from '../../../../hooks/usePackages';
import DashboardCards from '../../../../components/DashboardCard/DashboardCards';
import ActiveUsersCard from './ActiveUsersCard';
import useActiveUsers from './useActiveUsers';
import useEngagementSection from '../EngagementSection/useEngagementSection';

function SubHeading({
  enabled, viewOption, monthData, weekData,
}) {
  if (!enabled) return null;

  const {
    recentMonth,
    recentWeek,
    weekDiff,
    monthDiff,
    monthOp,
    weekOp,
    opObject,
  } = useEngagementSection({ monthData, weekData });

  const isMonth = viewOption === 'month';
  const label = isMonth ? 'Latest month' : 'Latest week';
  const value = isMonth ? recentMonth : recentWeek;
  const diff = isMonth ? monthDiff : weekDiff;
  const op = isMonth ? monthOp : weekOp;
  const icon = opObject?.[op];
  const diffColor = op === '+' ? 'success.main' : 'error.main';

  return (
    <Stack direction="row" gap={0.4} alignItems="center">
      <Typography variant="body2" fontWeight="bold" mr={0.5}>
        {label}
        :
      </Typography>
      <Typography variant="body2" color="textSecondary" fontWeight="bold">
        {value}
      </Typography>
      {icon && icon}
      {op !== '~' && (
        <Typography variant="body2" fontWeight="bold" sx={{ color: diffColor }}>
          {diff}
        </Typography>
      )}
    </Stack>
  );
}

export default function ActiveUsers(props) {
  const {
    accountName,
    accountId = null,
    refreshUsers,
    setRefreshUsers,
    more = true,
    page = 'dashboard',
    subHeading = false,
    isShareQuery = null,
  } = props;

  const {
    selectedPackage,
    packageList,
    handlePackageChange,
  } = usePackages({ defaultSelected: '-all-' });

  const {
    error,
    loading,
    weekData,
    monthData,
  } = useActiveUsers({
    page, accountId, packageId: selectedPackage, isShareQuery, refreshUsers,
  });

  const navigate = useNavigate();
  const [selectedView, setSelectedView] = useState('month');

  const handleClick = () => {
    const path = (!accountId || accountId === 'all') ? '/active-users' : `/account-page/active-users?accountId=${accountId}`;
    navigate(path, { state: { accountName, accountId, page } });
  };

  const getActiveUserProps = () => {
    if (selectedView === 'month') {
      return {
        title: 'Monthly Active Users',
        resultSet: monthData,
      };
    }
    return {
      title: 'Weekly Active Users',
      resultSet: weekData,
    };
  };

  const { title, resultSet } = getActiveUserProps();

  return (
    <DashboardCards
      view
      title={title}
      onClick={handleClick}
      showButton
      buttonText="more"
      subHeading={<SubHeading enabled={subHeading} viewOption={selectedView} monthData={monthData} weekData={weekData} />}
      viewOption={selectedView}
      setViewOption={setSelectedView}
      packageList={packageList}
      selectedPackage={selectedPackage}
      handlePackageChange={handlePackageChange}
    >
      <ActiveUsersCard
        loading={loading}
        error={error}
        data={resultSet}
        refresh={setRefreshUsers}
        more={more}
        message="No Data"
        viewOption={selectedView}
      />
    </DashboardCards>
  );
}
